'use client';

import Toast from '@/components/base/toast/toast';
import { useToastsStore } from '@/components/base/toast/use-toast';
import { useBreakpointUp } from '@/hooks/use-theme';
import { clsx } from 'clsx';

const ToastContainer = () => {
  const toasts = useToastsStore(({ toasts }) => toasts);
  const isDesktop = useBreakpointUp('s');

  return (
    <div
      className={clsx(
        'fixed top-0 z-top flex w-full flex-col gap-xxs pt-xs',
        isDesktop
          ? 'right-0 items-end'
          : '-translate-x-1/2 left-1/2 items-center',
      )}
    >
      {toasts.map((toastProps) => (
        <Toast key={toastProps.id} {...toastProps} />
      ))}
    </div>
  );
};

export default ToastContainer;
